export const WorkspaceConfig_DiseaseProfile_Likelihood = {
    name: 'Disease Property Data',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'leftPanel', key: 'likelihoodVariables', visible: true, factor: 1 / 2, min: 200,
                data: {}
            },
            {
                name: 'rightPanel', key: 'likelihoodValues', visible: true, factor: 1 / 2, min: 200,
                data: {}
            }
        ]
    }
};
